// extracted by mini-css-extract-plugin
export default {"c-select":"c-select__5facf1"};